import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IInformationMessage) {
    (function(Style) {
        Style["STYLE_UNKNOWN"] = "STYLE_UNKNOWN";
        Style["REGULAR"] = "REGULAR";
        Style["PROMO"] = "PROMO";
    })(IInformationMessage.Style || (IInformationMessage.Style = {}));
    (function(Type) {
        Type["TYPE_UNKNOWN"] = "TYPE_UNKNOWN";
        Type["BASED_IN"] = "BASED_IN";
        Type["SHIPS_FROM"] = "SHIPS_FROM";
        Type["ORDER_FULFILLMENT_TIME"] = "ORDER_FULFILLMENT_TIME";
        Type["PREORDER"] = "PREORDER";
        Type["INTERNATIONAL_SHIPPING_PROMO"] = "INTERNATIONAL_SHIPPING_PROMO";
        Type["INTERNATIONAL_DUTIES_PROMO"] = "INTERNATIONAL_DUTIES_PROMO";
        Type["CATEGORY_RESTRICTION"] = "CATEGORY_RESTRICTION";
        Type["INSIDER_UPSELL"] = "INSIDER_UPSELL";
        Type["INSIDER_EVENT_CHECKOUT_UPSELL"] = "INSIDER_EVENT_CHECKOUT_UPSELL";
        Type["GREEN_SHIPPING_UPSELL"] = "GREEN_SHIPPING_UPSELL";
        Type["FAIRE_FUNDED_PROMO_BANNER"] = "FAIRE_FUNDED_PROMO_BANNER";
        Type["INSIDER_UNPAID_NOTICE"] = "INSIDER_UNPAID_NOTICE";
        Type["INSIDER_UNPAID_RECOVER"] = "INSIDER_UNPAID_RECOVER";
        Type["ZERO_DOLLAR_ORDER"] = "ZERO_DOLLAR_ORDER";
        Type["ZERO_DOLLAR_ORDER_WITH_ADDITIONAL_COST"] = "ZERO_DOLLAR_ORDER_WITH_ADDITIONAL_COST";
        Type["BACKORDERED_ORDER"] = "BACKORDERED_ORDER";
        Type["IDV_REQUIRED"] = "IDV_REQUIRED";
        Type["AWAITING_APPROVAL"] = "AWAITING_APPROVAL";
        Type["AWAITING_PAYMENT_METHOD"] = "AWAITING_PAYMENT_METHOD";
        Type["APPAREL_NEW_USER_EXPERIENCE"] = "APPAREL_NEW_USER_EXPERIENCE";
        Type["FIRST_ORDER_PROMO"] = "FIRST_ORDER_PROMO";
        Type["SHIPPING_ESTIMATE"] = "SHIPPING_ESTIMATE";
        Type["MARKET_PROMO"] = "MARKET_PROMO";
        Type["GET_IT_BY"] = "GET_IT_BY";
        Type["EXCLUSIVITY_PROMO_BANNER"] = "EXCLUSIVITY_PROMO_BANNER";
        Type["SHIPPING_COST_ESTIMATE_BREAKDOWN"] = "SHIPPING_COST_ESTIMATE_BREAKDOWN";
        Type["INSIDER_UNDER_THRESHOLD"] = "INSIDER_UNDER_THRESHOLD";
        Type["FREE_RETURNS_ON_FIRST_ORDER"] = "FREE_RETURNS_ON_FIRST_ORDER";
        Type["EXCLUSIVITY_AVAILABLE"] = "EXCLUSIVITY_AVAILABLE";
        Type["EXCLUSIVITY_ACTIVE"] = "EXCLUSIVITY_ACTIVE";
        Type["FAIRE_FUNDED_GUARANTEED_SHIPPING"] = "FAIRE_FUNDED_GUARANTEED_SHIPPING";
        Type["FAIRE_FUNDED_GUARANTEED_SHIPPING_WITH_DISCLAIMER"] = "FAIRE_FUNDED_GUARANTEED_SHIPPING_WITH_DISCLAIMER";
        Type["GUARANTEED_FREE_SHIPPING_THRESHOLD"] = "GUARANTEED_FREE_SHIPPING_THRESHOLD";
        Type["SHIPPING_COST_SAVING"] = "SHIPPING_COST_SAVING";
    })(IInformationMessage.Type || (IInformationMessage.Type = {}));
    (function(Position) {
        Position["POSITION_UNKNOWN"] = "POSITION_UNKNOWN";
        Position["DEFAULT"] = "DEFAULT";
        Position["BOTTOM"] = "BOTTOM";
    })(IInformationMessage.Position || (IInformationMessage.Position = {}));
    IInformationMessage.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IInformationMessage || (IInformationMessage = {}));
export var IInformationMessage;
